import Box from '@/components/UI/box/Box'
import shabLogo from '@/public/images/auth/shabLogo.svg'
import Typography from '@/components/UI/typography/Typography'
import styles from './Header.module.scss'
import Image from 'next/image'
import { useRouter } from 'next/router'
import Icon from '@/components/UI/icon/Icon'
import Divider from '@/components/UI/divider/Divider'
import useLogin from '../../hooks/useLogin'
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider'

const titleSet = {
  GETPHONENUMBER: 'ورود یا ثبت‌نام',
  GETVERIFICATIONCODE: 'تایید شماره همراه',
  GETINFORMATION: 'تکمیل اطلاعات',
  SHOWHOSTPANELCTA: 'راهنمای میزبان',
}

const Header = () => {
  const { step, onClose } = useLogin()
  const isWhiteLabel = useIsWhiteLabel()
  const router = useRouter()
  const isLoginPage = router.asPath?.includes('/login')
  return (
    <Box className={styles['header']}>
      <Box className={styles['content']}>
        <Box className={styles['title']}>
          {!isLoginPage && onClose && (
            <Icon
              size="large"
              type={'secondary'}
              name={'close'}
              onClick={() => onClose()}
              className={styles['close-icon']}
            />
          )}
          {titleSet[step] && (
            <Typography variant="bodyL">{titleSet[step]}</Typography>
          )}
        </Box>
        {!isWhiteLabel && (
          <Box
            onClick={() => {
              if (isLoginPage) {
                router.push('/')
              }
            }}
          >
            <Image src={shabLogo} alt="shab-logo" />
          </Box>
        )}
      </Box>
      <Divider orientation="horizontal" />
    </Box>
  )
}

export default Header
